'use client'

import { useEffect, useState } from 'react'

export function useIsEmbedded(initialIsEmbedded = false): boolean {
  // 🥷🏼 use the server-provided value for hydration, then verify the browser frame state.
  // 🥷🏼 `window.self !== window.top` is unknowable on the server, so don't read it in a lazy initializer.
  const [isEmbedded, setIsEmbedded] = useState(initialIsEmbedded)

  useEffect(() => {
    setIsEmbedded(window.self !== window.top)
  }, [])

  return isEmbedded
}
